import React from 'react';
import { Card, CardContent, CardDescription, CardHeader, CardTitle } from '../../components/ui/card';
import { Table, TableBody, TableCell, TableHead, TableHeader, TableRow } from '../../components/ui/table';
import { Button } from '../../components/ui/button';
import { Calendar, CheckCircle, Mail } from 'lucide-react';

export const ExpiringTab = ({ expiringSoon, handleBulkRenewal, handleSendRenewal }) => {
  return (
    <Card className="border-0 shadow-lg">
      <CardHeader>
        <div className="flex items-center justify-between">
          <div>
            <CardTitle className="text-xl flex items-center gap-2">
              <Calendar className="w-5 h-5 text-amber-500" />Membresías por Vencer
            </CardTitle>
            <CardDescription>Próximos 60 días — {expiringSoon.length} membresía(s)</CardDescription>
          </div>
          <Button variant="outline" className="border-amber-300 text-amber-700 hover:bg-amber-50" onClick={handleBulkRenewal} data-testid="bulk-renewal-btn">
            <Mail className="w-4 h-4 mr-2" />Enviar recordatorios masivos
          </Button>
        </div>
      </CardHeader>
      <CardContent>
        {expiringSoon.length === 0 ? (
          <div className="text-center py-16 text-gray-400">
            <CheckCircle className="w-12 h-12 mx-auto mb-4 opacity-30" />
            <p className="text-lg font-medium">No hay membresías próximas a vencer</p>
          </div>
        ) : (
          <Table>
            <TableHeader>
              <TableRow className="bg-amber-50">
                <TableHead>Usuario</TableHead>
                <TableHead>Email</TableHead>
                <TableHead>Teléfono</TableHead>
                <TableHead>Código</TableHead>
                <TableHead>Vence</TableHead>
                <TableHead>Días restantes</TableHead>
                <TableHead className="text-center">Acción</TableHead>
              </TableRow>
            </TableHeader>
            <TableBody>
              {expiringSoon.map((m) => (
                <TableRow key={m.id} className={m.days_remaining <= 7 ? 'bg-red-50' : m.days_remaining <= 15 ? 'bg-amber-50/50' : ''}>
                  <TableCell className="font-medium">{m.user_name}</TableCell>
                  <TableCell className="text-gray-500">{m.user_email}</TableCell>
                  <TableCell className="text-gray-500">{m.user_phone || '-'}</TableCell>
                  <TableCell className="font-mono text-sm">{m.card_code}</TableCell>
                  <TableCell className="text-sm">{new Date(m.expiry_date).toLocaleDateString('es-MX')}</TableCell>
                  <TableCell>
                    <span className={`font-bold ${m.days_remaining <= 7 ? 'text-red-600' : m.days_remaining <= 15 ? 'text-amber-600' : 'text-gray-700'}`}>
                      {m.days_remaining} días
                    </span>
                  </TableCell>
                  <TableCell className="text-center">
                    <Button variant="ghost" size="sm" onClick={() => handleSendRenewal(m.id)}>
                      <Mail className="w-4 h-4 text-amber-600" />
                    </Button>
                  </TableCell>
                </TableRow>
              ))}
            </TableBody>
          </Table>
        )}
      </CardContent>
    </Card>
  );
};
